<template>
  <div id="page-wrapper">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">
          <i class="fa fa-dashboard fa-fw"></i>Dashboard
        </h1>
      </div>
      <!-- /.col-lg-12 -->
    </div>
    <!-- /.row -->
    <div v-if="isAdmin" class="row">
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-primary">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-sign-in fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ incomming }}</div>
                <div>Novas Solicitações</div>
              </div>
            </div>
          </div>
          <router-link to="admin/accreditations?type=novas">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-yellow">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-hourglass-start fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ underAnalisys }}</div>
                <div>Em Análise</div>
              </div>
            </div>
          </div>
          <router-link to="admin/accreditations?type=emAnalise">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-green">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-check fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ success }}</div>
                <div>Liberadas</div>
              </div>
            </div>
          </div>
          <router-link to="admin/accreditations?type=liberadas">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-red">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-times fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ declined }}</div>
                <div>Bloqueadas</div>
              </div>
            </div>
          </div>
          <router-link to="admin/accreditations?type=bloqueadas">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div v-else-if="!isAdmin" class="row">
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-primary">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-sign-in fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ incomming }}</div>
                <div>Novas Solicitações</div>
              </div>
            </div>
          </div>
          <!--router-link to="admin/my-accreditations?type=novas">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link-->
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-yellow">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-hourglass-start fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ underAnalisys }}</div>
                <div>Em Análise</div>
              </div>
            </div>
          </div>
          <!--router-link to="admin/my-accreditations?type=emAnalise">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link-->
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-green">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-check fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ success }}</div>
                <div>Liberadas</div>
              </div>
            </div>
          </div>
          <!--router-link to="admin/my-accreditations?type=liberadas">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link-->
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="panel panel-red">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-3">
                <i class="fa fa-times fa-5x"></i>
              </div>
              <div class="col-xs-9 text-right">
                <div class="huge">{{ declined }}</div>
                <div>Bloqueadas</div>
              </div>
            </div>
          </div>
          <!--router-link to="admin/my-accreditations?type=bloqueadas">
            <div class="panel-footer">
              <span class="pull-left">Ver detalhes</span>
              <span class="pull-right"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <div class="clearfix"></div>
            </div>
          </router-link-->
        </div>
      </div>
    </div>
    <!-- /.row -->
    <div v-if="isAdmin" class="row">
      <div class="col-lg-8">
        <div class="panel panel-default">
          <div class="panel-heading">
            <i class="fa fa-bar-chart-o fa-fw"></i>
            Minhas Tarefas
          </div>
          <!-- /.panel-heading -->
          <div class="panel-body" v-if="isAdmin">
            <table class="table table-bordered table-condensed">
              <thead>
                <td>#</td>
                <td>Empresa</td>
                <td>Atividade</td>
                <td>Documento</td>
                <td>Estado</td>
                <td>Avaliar</td>
              </thead>
              <tbody>
                <tr v-for="p in pendding" :key="p.id">
                  <td>{{ p.id }}</td>
                  <td>{{ p.personName }}</td>
                  <td>{{ p.activityName }}</td>
                  <td>{{ p.rule.name }}</td>
                  <td>{{p.state}}</td>
                  <td>
                    <router-link 
                      :to="'/admin/persons?edit='+p.personId+'&activity=' + p.activityId"
                      class="btn btn-default btn-block">
                      <i class="fa fa-search"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.panel-body -->
        </div>
        <!-- /.panel -->
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-4">
        <div class="panel panel-default" v-if="isAdmin">
          <div class="panel-heading">
            <i class="fa fa-bar-chart-o fa-fw"></i> Status Geral Empresas
          </div>
          <div class="panel-body">
            <div id="morris-donut-chart"></div>
            <router-link
              to="admin/accreditations?type=novas"
              class="btn btn-default btn-block"
              >Ver os detalhes
            </router-link>
          </div>
          <!-- /.panel-body -->
        </div>
        <!-- /.panel -->
      </div>
      <!-- /.col-lg-4 -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /#page-wrapper -->
</template>

<script>
import storage from "../mixins/storage";

export default {
  name: "DashBoard",
  data() {
    return {
      pendding: [],
      histories: [],
      search: "",
      incomming: null,
      underAnalisys: null,
      success: null,
      declined: null,
      isAdmin: null,
      accreditations: [],
    };
  },
  methods: {
    countUp(value, speed, increment) {
      const initialValue = this[value];
      this[value] = 0;

      setInterval(() => {
        if (this[value] < initialValue) {
          this[value] += increment || 1;
        }
      }, speed || 10);
    },
    linkEmpresa(empresaId) {
      this.$router.push(`admin/persons?empresaId=${empresaId}`);
    },
  },
  computed: {
    dataAtual() {
      const date = new Date();
      return date.toISOString();
    },
    filtred() {
      const search = this.search.toLowerCase().trim();
      let result = [];

      if (!search) {
        result = this.histories;
      }

      result = this.histories.filter((a) => {
        const field = a.name || "";

        return field.toLowerCase().indexOf(search) > -1;
      });

      return result.sort((a, b) => b.id - a.id);
    },
    novas() {
      return this.accreditations.filter(
        (a) => a.state == "" || a.state == undefined
      );
    },
    emAnalise() {
      return this.accreditations.filter((a) => a.state === "emAnalise");
    },
    liberados() {
      return this.accreditations.filter((a) => a.state === "liberado");
    },
    bloqueados() {
      return this.accreditations.filter((a) => a.state === "bloqueado");
    },
  },
  mounted() {
    this.$http
      .get("/accreditation-itens/pendding")
      .then((response) => {
        const user = storage.methods.getUser();
        const itens = response.data;
        this.pendding = itens.filter(
          (item) => item.rule.sectorId === user.sectorId
        );
      })
      .catch((error) => console.log(error));

    this.$http.get("/history/").then((response) => {
      this.histories = response.data;
    });
    this.$http
      .get(`/auth/info/${storage.methods.getToken()}`)
      .then((response) => {
        this.user = response.data;
        this.$http.get("accreditation").then((response) => {
          this.accreditations = response.data;
          this.success = this.liberados.length;
          this.underAnalisys = this.emAnalise.length;
          this.incomming = this.novas.length;
          this.declined = this.bloqueados.length;

          /* this.$nextTick(() => {
            if (this.isAdmin) {
              Morris.Donut({
                element: document.querySelector("#morris-donut-chart"),
                data: [
                  {
                    label: "Novas",
                    value: this.incomming,
                    color: "#115293",
                  },
                  {
                    label: "Em Análise",
                    value: this.underAnalisys,
                    color: "#f57c00",
                  },
                  {
                    label: "Bloqueados",
                    value: this.declined,
                    color: "#9a0036",
                  },
                  {
                    label: "Liberados",
                    value: this.success,
                    color: "#198754",
                  },
                ],
                resize: true,
              });
            }
            
          });*/
        });
      });
    this.countUp("success", 0.4, 3);
    this.countUp("declined", 2);
    this.countUp("incomming", 2);
    this.countUp("underAnalisys", 2);
    this.isAdmin = storage.methods.isAdmin();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DashBoard.vue